import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { OrganizationChart } from '../components/OrganizationChart';
import { ACTIONS, RESOURCES } from "../constants/permissions.constants";
import { Shield } from "lucide-react";
import { Button } from "../components/ui/button";
import { useNavigate } from "react-router-dom";
import { Can } from "../components/Can";

export default function OrganizationPage() {
  const navigate = useNavigate();

  return (
    <Can I={ACTIONS.READ} a={RESOURCES.ORGANISATION_CHART} passThrough={
      <div className="flex flex-col items-center justify-center h-[50vh] space-y-4">
        <Shield size={48} className="text-muted-foreground" />
        <h2 className="text-xl font-semibold">Access Restricted</h2>
        <p className="text-muted-foreground">You don't have permission to access the organization chart.</p>
        <Button variant="outline" onClick={() => navigate("/dashboard")}>
          Back to Dashboard
        </Button>
      </div>
    }>
      <div className="space-y-4">
        <div className="flex justify-between items-center">
          <h1 className="text-2xl font-bold">Organization Chart</h1>
        </div>

        <Card className="h-[calc(100vh-180px)]">
          <CardHeader className="pb-2">
            <CardTitle className="text-lg">Company Structure</CardTitle>
          </CardHeader>
          <CardContent className="h-[calc(100%-70px)]">
            <OrganizationChart />
          </CardContent>
        </Card>
      </div>
    </Can>
  );
}
